<template>
    <div class="mx-auto">
        <page-title :title="$t('thematicArea.thematicAreaProposal')" :show-title="false"></page-title>
        <div class="card row">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5">{{ $t('thematicArea.thematicAreaProposal') }}</div>
            </div>
            <div class="card-body row">
                <div class="form-group col-md-6">
                    <label class="font-weight-bold required">{{ $t('thematicArea.theme') }} / {{ $t('thematicArea.thematicArea') }}</label>
                    <input class="form-control"
                           id="thematicArea"
                           :name="'thematicArea'"
                           :data-vv-as="$t('thematicArea.theme') "
                           v-validate="'required'"
                           v-model="thematicAreaProposal.thematicArea">
                    <span class="text-danger col-12" v-if="errors.has('thematicArea')">{{ errors.first('thematicArea') }}</span>
                </div>
                <div class="form-group col-md-6">
                    <label class="font-weight-bold required">{{ $t('thematicArea.legalArea') }}</label>
                    <dropdown :type="'Правна област'" :required="true" :fieldName="$t('thematicArea.legalArea')"
                        v-model="thematicAreaProposal.legalAreaId"></dropdown>
                </div>
            </div>
            <div class="card-footer text-center">
                <button type="button" class="btn btn-primary btn" @click="onSubmit">
                    <i class="fas fa-save"></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropdown from '../../components/dropdown/NomenclatureDropdown'
    import PageTitle from '../../components/common/PageTitle'
    import { ThematicAreaProposalModel } from '../../models/models'

    export default {
        components: {
            Dropdown,
            PageTitle
        },
        data() {
            return {
                thematicAreaProposal: new ThematicAreaProposalModel()
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.$http.post('/api/ThematicAreaProposal/AddProposal', this.thematicAreaProposal)
                            .then(result => {
                                this.thematicAreaProposal = new ThematicAreaProposalModel();
                                this.$vs.notify({
                                    title: this.$t('notifications.success'),
                                    text: this.$t('notifications.successfulSavedData'),
                                    position: 'top-center',
                                    color: 'success'
                                });
                            })
                            .catch((error => {
                                this.$vs.notify({
                                    title: this.$t('notifications.error'),
                                    text: this.$t('notifications.errorDataNotSaved'),
                                    position: 'top-center',
                                    color: 'danger'
                                });
                            }));
                    }
                });
            }
        }
    }
</script>
